// vim: sts=2:ts=2:sw=2
/* jshint undef: true, unused: true */
/* jshint browser: true */

//import * as d3 from 'd3';
import jQuery from 'jquery';

const $ = jQuery;

const charting = {
  margins: {top: 10, right: 50, bottom: 30, left: 50},
  width: 900, // TODO choose dynamically
  height: 280,
  //colors: d3.scale.ordinal().domain(['default', 'latest']).range(['#1f77b4', '#2CA9FF']),
  url: function($container, chart_id){
    var url_base=$(chart_id).data('url');
    var qsa_params = {};
    $container.find('form *').filter(':input').each(function(ids, elem){
      qsa_params[elem.name] = elem.value;
    });
    if (url_base.indexOf('?') > 0)
      return url_base + '&' + $.param(qsa_params);
    return url_base + '?' + $.param(qsa_params);
  },
  unique_id_cnt: 1,
  unique_id: function(elm) {
    $(elm).attr('id', 'unique-' + this.unique_id_cnt++);
  }
};

export {
  charting,
};
